import domReady from "@wordpress/dom-ready";

domReady(() => {
	const clickToRevealItems = document.querySelectorAll(
		".wp-block-qasas-companion-click-to-reveal-toggle",
	);
	if (!clickToRevealItems.length) return;

	clickToRevealItems.forEach((item) => {
		const customCursor = item.querySelector(".click-to-reveal-custom-cursor");
		if (!customCursor) return; // Skip if custom cursor element doesn't exist

		item.addEventListener("click", () => {
			item.classList.toggle("is-open");
		});

		// Update the custom cursor position based on mouse movement
		item.addEventListener("mousemove", (e) => {
			const rect = item.getBoundingClientRect();
			const x = e.clientX - rect.left;
			const y = e.clientY - rect.top;

			customCursor.style.left = `${x}px`;
			customCursor.style.top = `${y}px`;
			customCursor.style.opacity = "1";
		});

		// Hide the cursor when the mouse leaves the section
		item.addEventListener("mouseleave", () => {
			customCursor.style.opacity = "0";
		});
	});
});
